module.exports = __webpack_public_path__ + "img/open.1a3f58be.png";